<div class="product-detail-wrapper">

  <header class="detail-header">
    <div class="banner-wrapper" *ngIf="product?.banners">
      <gob-banner [banners]="product.banners"></gob-banner>
    </div>

    <h1>{{product.name}}</h1>

    <div class="meta-info">
      <div class="rating-block">
        <gob-stars [stars]="product?.stars"></gob-stars>

        <ng-container *ngIf="product?.stars">
          <a class="review-link" (click)="scrollToReviews()">
            (Voir les avis)
          </a>
          <span class="separator">|</span>
          <a class="write-review-link" data-bs-toggle="modal" data-bs-target="#ratingModal">
            Laisser un avis
          </a>
        </ng-container>

        <a class="no-review" *ngIf="!product?.stars" data-bs-toggle="modal" data-bs-target="#ratingModal">
          Soyez le premier à donner votre avis !
        </a>
      </div>
      <span class="separator hidden-phone" *ngIf="product.ref">|</span>
      <span class="ref hidden-phone" *ngIf="product.ref">Réf: {{product.ref}}</span>
    </div>

    <div class="subtitle" *ngIf="product.subtitle">
      {{product.subtitle}}
    </div>
  </header>

  <div class="gallery-mobile display-phone">
    <gob-gallery [product]="product"></gob-gallery>
  </div>

  <div class="specs-grid">
    <div class="spec-item" *ngIf="product.players">
      <div class="icon"><i class="fa-regular fa-users"></i></div>
      <div class="text">
        <strong>{{product.players}}<ng-container *ngIf="product.playersMax"> - {{product.playersMax}}</ng-container></strong>
        <span>Joueurs</span>
      </div>
    </div>

    <div class="spec-item" *ngIf="product.duration">
      <div class="icon"><i class="fa-regular fa-clock"></i></div>
      <div class="text">
        <strong>{{product.duration}} min</strong>
        <span>Durée</span>
      </div>
    </div>

    <div class="spec-item" *ngIf="product.age">
      <div class="icon"><i class="fa-regular fa-cake-candles"></i></div>
      <div class="text">
        <strong>{{product.age}}+</strong>
        <span>Ans</span>
      </div>
    </div>
  </div>

  <div class="tags-container" *ngIf="product?.tags && product.tags.length > 0">
    <span class="tag-pill" *ngFor="let tag of product.tags">
      <i class="fa-solid fa-tag"></i> {{tag.name}}
    </span>
  </div>

  <div class="purchase-card">
    <div *ngIf="product | getPrices:0" class="price-row">
      <ng-container *ngIf="(product | getPrices:0)?.discounted">
        <div class="main-price promo">{{product | getPrices:0 | formatPrice}}€</div>
        <div class="old-price">{{product | getPrices:0 | formatPrice:true}}€</div>
      </ng-container>
      <ng-container *ngIf="!(product | getPrices:0)?.discounted && !(product | getPrices:1)">
        <div class="main-price">{{product | getPrices:0 | formatPrice}}€</div>
      </ng-container>
      <ng-container *ngIf="product | getPrices:1">
        <div class="main-price">{{priceSelected | formatPrice}}€ <small>(le lot)</small></div>
      </ng-container>
    </div>

    <div class="stock-info">
      <div *ngIf="cart.orderOnlineOnly(product)" class="status online-only">
        <i class="fa-solid fa-store"></i> Exclusivement en boutique
        <small>Disponible uniquement en magasin</small>
      </div>
      <div *ngIf="cart.getPreOrderDateIfAny(product)" class="status preorder">
        <i class="fa-solid fa-hourglass-half"></i> Précommande
        <small>Livraison dès le {{ releaseDate | date:'fullDate':'':'fr-FR' }}</small>
      </div>
      <div *ngIf="!cart.canOrder(product) && !cart.orderOnlineOnly(product)" class="status out">
        <i class="fa-solid fa-ban"></i> Rupture de stock
      </div>
      <div *ngIf="cart.canOrder(product) && !cart.orderOnlineOnly(product) && !cart.getPreOrderDateIfAny(product)">
        <div class="status in-stock">
          <i class="fa-solid fa-check-circle"></i> En stock
          <small>Expédié le {{ today | date:'dd/MM':'':'fr-FR' }}</small>
        </div>
      </div>

      <!-- Click & collect : affiché en stock ET en précommande -->
      <div *ngIf="cart.canOrder(product) && !cart.orderOnlineOnly(product)" class="click-collect">
        <button class="cc-trigger" type="button" data-bs-toggle="collapse" data-bs-target="#cc-info">
          <span><i class="fa-solid fa-store"></i> Possibilité de retrait boutique gratuit</span>
          <i class="fa-solid fa-chevron-down ms-3"></i>
        </button>
        <div class="collapse" id="cc-info">
          <div class="cc-content">

            <div *ngFor="let depot of depots" class="shop-avail available">
              <i class="fa-solid fa-check"></i> Disponible en boutique à <b>{{ depot.name }}</b>
              <!-- En précommande : préciser à partir de quelle date -->
              <ng-container *ngIf="cart.getPreOrderDateIfAny(product)">
                à partir du {{ releaseDate | date:'dd/MM' }}
              </ng-container>
            </div>

            <div *ngFor="let depot of depotsWithNoStock" class="shop-avail order">
              <i class="fa-solid fa-clock"></i> <b>{{ depot.name }}</b> : le
              <!-- En précommande : date de sortie, sinon date habituelle -->
              <ng-container *ngIf="cart.getPreOrderDateIfAny(product)">
                {{ releaseDate | date:'dd/MM' }}
              </ng-container>
              <ng-container *ngIf="!cart.getPreOrderDateIfAny(product)">
                {{ later | date:'dd/MM' }}
              </ng-container>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div *ngIf="product | getPrices:1" class="colisage-row">
      <select (change)="setPrice(priceVal.value)" #priceVal class="form-select">
        <option *ngFor="let price of product | getPrices" [value]="price.ident" [selected]="priceSelected.ident==price.ident">
          x{{price.qte}} - {{price | formatPrice}}€
        </option>
      </select>
    </div>

    <div *ngIf="!cart.orderOnlineOnly(product) && cart.canOrder(product)" class="actions-wrapper">
      <div class="qty-selector">
        <button (click)="minus(qte)" [disabled]="isMinQte(qte.value)" class="qty-btn">
          <i class="fa-solid fa-minus"></i>
        </button>
        <input type="number" #qte value="1" min="1" readonly>
        <button (click)="add(qte)" [disabled]="isMaxQte(qte.value)" class="qty-btn">
          <i class="fa-solid fa-plus"></i>
        </button>
      </div>

      <button (click)="addCart(product, priceSelected, qte.value)" class="add-to-cart-btn" [disabled]="!(product | getPrices:0)">
        <span class="icon-cart"><i class="fa-solid fa-basket-shopping"></i></span>
        <span class="text hidden-phone">Ajouter au panier</span>
        <span class="text display-phone">Ajouter</span>
      </button>
    </div>

    <div *ngIf="!cart.orderOnlineOnly(product) && !cart.canOrder(product)" class="actions-wrapper">
      <button (click)="openAlertModal()" class="alert-notify-btn">
        <span class="icon-bell"><i class="fa-solid fa-bell"></i></span>
        <span class="text hidden-phone">M'avertir du retour en stock</span>
        <span class="text display-phone">M'avertir</span>
      </button>
    </div>

  <div class="delivery-strip">
    <i class="fa-solid fa-truck-fast"></i>
    <span>Livraison dès <b>2€</b> | Offerte dès <b>60€</b></span>
  </div>

  <div *ngIf="product.video" class="video-accordion">
    <div class="accordion" id="videoAcc">
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#videoContent">
            <i class="fa-brands fa-youtube" style="color: #c4302b; margin-right: 10px;"></i> Voir la vidéo de présentation
          </button>
        </h2>
        <div id="videoContent" class="accordion-collapse collapse" data-bs-parent="#videoAcc">
          <div class="accordion-body">
            <gob-youtube [id]="product.video"></gob-youtube>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<div class="modal fade" id="ratingModal" tabindex="-1" aria-labelledby="ratingModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="ratingModalLabel">VOTRE AVIS NOUS INTÉRESSE</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <gob-rating-form [product]="product"></gob-rating-form>
      </div>
    </div>
  </div>
</div>

<gob-alert-modal
  [isOpen]="isAlertOpen"
  [productName]="product.name"
  [productId]="product.ident"
  (closeEvent)="isAlertOpen = false">
</gob-alert-modal>